import PropTypes from 'prop-types'
import { P1, Font } from '@moneymade/moneymade-ui'

import { toSignCorrectDisplayValue } from 'modules/asset/AssetPage/assetPageUtils'
import { toMoneyFormat } from 'utils'
import styles from './HighLow.module.scss'

const HighLow = ({
  slugFirst,
  slugCurrency,
  slugSecond,
  slugCompareCurrency,
  data: {
    slugFirst: { high: slugFirstHigh, low: slugFirstLow } = {},
    slugSecond: { high: slugSecondHigh, low: slugSecondLow } = {}
  },
  timeFrame
}) => (
  <div className={styles.HighLow}>
    <div className={styles.Header}>
      <div />

      <Font
        as="p"
        weight="light"
        font={{
          default: { fontSize: '14px', lineHeight: '26px' }
        }}
        className={styles.Title}
      >
        {`${timeFrame} High`}
      </Font>

      <Font
        as="p"
        weight="light"
        font={{
          default: { fontSize: '14px', lineHeight: '26px' }
        }}
        className={styles.Title}
      >
        {`${timeFrame}  Low`}
      </Font>
    </div>

    <div className={styles.Row}>
      <div className={styles.NameContainer}>
        <img alt="circle" src="https://assets.moneymade.io/images/AssetPage/Circle.svg" />
        <P1 className={styles.High}>{slugFirst}</P1>
      </div>
      <P1 weight="light">{toSignCorrectDisplayValue(toMoneyFormat(slugFirstHigh?.toFixed(2) || 0), slugCurrency)}</P1>
      <P1 weight="light">{toSignCorrectDisplayValue(toMoneyFormat(slugFirstLow?.toFixed(2) || 0), slugCurrency)}</P1>
    </div>

    <div className={styles.HL} />

    <div className={styles.Row}>
      <div className={styles.NameContainer}>
        <img alt="circle" src="https://assets.moneymade.io/images/AssetPage/CircleDashed.svg" />
        <P1 className={styles.High}>{slugSecond}</P1>
      </div>

      <P1 weight="light">
        {toSignCorrectDisplayValue(toMoneyFormat(slugSecondHigh?.toFixed(2) || 0), slugCompareCurrency)}
      </P1>
      <P1 weight="light">
        {toSignCorrectDisplayValue(toMoneyFormat(slugSecondLow?.toFixed(2) || 0), slugCompareCurrency)}
      </P1>
    </div>
  </div>
)

HighLow.propTypes = {
  slugFirst: PropTypes.string,
  slugCurrency: PropTypes.string,
  slugSecond: PropTypes.string,
  slugCompareCurrency: PropTypes.string,
  data: PropTypes.shape({
    slugFirst: PropTypes.shape({
      high: PropTypes.number,
      low: PropTypes.number
    }),
    slugSecond: PropTypes.shape({
      high: PropTypes.number,
      low: PropTypes.number
    })
  }),
  timeFrame: PropTypes.string
}

HighLow.defaultProps = {
  slugFirst: '',
  slugCurrency: '',
  slugSecond: '',
  slugCompareCurrency: '',
  data: {
    slugFirst: {
      high: 0,
      low: 0
    },
    slugSecond: {
      high: 0,
      low: 0
    }
  },
  timeFrame: ''
}

export default HighLow
